import { forwardRef, type InputHTMLAttributes } from "react";

export interface NumberInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {}

/**
 * Drop-in replacement for <input type="number">.
 * Blurs on wheel scroll to prevent silent value mutation when scrolling
 * the page with a focused number input (J3 — Jack feedback Day 46).
 */
export const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(
  function NumberInput({ onWheel, ...rest }, ref) {
    return (
      <input
        ref={ref}
        type="number"
        onWheel={(e) => {
          e.currentTarget.blur();
          onWheel?.(e);
        }}
        {...rest}
      />
    );
  }
);
